import { Button } from "antd";
import classNames from "classnames";
import { PropsWithChildren } from "react";

interface WithSaveButtonProps {
    onSave?: () => void;
    className?: string;
}

export const WithSaveButton = ({ children, onSave, className }: PropsWithChildren<WithSaveButtonProps>) => {
    return (
        <div className={classNames("flex items-center gap-2 w-full bg-white p-2 border rounded", className)}>
            {children}
            <Button
                htmlType={"button"}
                type={"primary"}
                size={"middle"}
                onClick={(e) => {
                    e.stopPropagation();
                    onSave?.();
                }}
            >
                {"Save"}
            </Button>
        </div>
    );
};
